import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import EmployeeFormPresenter from "./EmployeeFormPresenter";
import CardView from "../../../../components/common/CardView";
import { item } from "../process/item";
import NavBar from "../../../../components/navigation";
import PersonalInfo from "../forms/personal-info/PersonalInfo";
import Employment from "../forms/employment/Employment";
import OtherInfo from "../forms/OtherInfo";
import Attachment from "../forms/Attachment";
import AdditionalInfo from "../forms/additional-info/AdditionalInfo";
// import { processSessionData } from "../../../../components/common/Converter";
import { Spin, Steps } from "antd";
import { v4 as uuidv4 } from "uuid";
import { FloatingForm } from "../../../../components/common/Converter";
class EmployeeFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      activeTab: "Personal Information", // Initialize active tab state
      personalInfo: [],
      isLoading: false,
    };
    this.presenter = new EmployeeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "employees";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleMenuItemClick(itemName) {
    this.setState({ activeTab: itemName });
  }

  onChangeTab(e) {
    if (this.state.activeTab === "Personal Information") {
      this.setState({ activeTab: "Employment 201" });
    } else if (this.state.activeTab === "Employment 201") {
      this.setState({ activeTab: "Other Information" });
    } else if (this.state.activeTab === "Other Information") {
      this.setState({ activeTab: "Additional Information" });
    } else if (this.state.activeTab === "Additional Information") {
      this.setState({ activeTab: "Attachments" });
    }
  }

  onClickPrev() {
    let prevTab;
    switch (this.state.activeTab) {
      case "Employment 201":
        prevTab = "Personal Information";
        break;
      case "Other Information":
        prevTab = "Employment 201";
        break;
      case "Additional Information":
        prevTab = "Other Information";
        break;
      case "Attachments":
        prevTab = "Additional Information";
        break;
      default:
        prevTab = this.state.activeTab;
    }
    this.setState({ activeTab: prevTab });
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    let objectID = this.getObjectId();
    if (this.getObjectId() === undefined) {
      this.onChange(uuidv4(), "id");
      objectID = uuidv4();
    }

    sessionStorage.setItem("OBJECT_ID", objectID);
  }

  // handleSessionData = (
  //   dataKey,
  //   deletionMethod,
  //   restorationMethod,
  //   storageKey
  // ) => {
  //   const data = JSON.parse(sessionStorage.getItem(dataKey)) || [];
  //   const deletedData = JSON.parse(sessionStorage.getItem(storageKey)) || [];

  //   if (data.length > 0) {
  //     deletionMethod(data, dataKey);
  //   } else if (deletedData.length > 0) {
  //     restorationMethod(deletedData, dataKey);
  //   }
  // };

  // CleanLocalStorage() {
  //   [
  //     "LeaveCredit",
  //     "DeletedCredits",
  //     "Children",
  //     "DeletedChildren",
  //     "Education",
  //     "DeleteEducation",
  //     "CivilService",
  //     "DeleteCivilSevice",
  //     "Voluntary",
  //     "DeleteVoluntary",
  //     "WorkExp",
  //     "DeleteWork",
  //     "LearningDev",
  //     "DeleteLearning",
  //     "OtherInfo",
  //     "DeleteOtherInfo",
  //     "Reference",
  //     "DeleteReference",
  //     "Contributions",
  //     "DeleteContribution",
  //     "AllowanceBene",
  //     "DeleteAllowance",
  //     "Loans",
  //     "DeleteLoans",
  //   ].forEach((item) => localStorage.removeItem(item));
  // }

  // async componentWillUnmount() {
  //   window.removeEventListener("beforeunload", this.handleBeforeUnload);
  //   const objectID = this.getObjectId();

  //   if (!this.state.isSubmit) {
  //     const dataTypes = [
  //       {
  //         key: "LeaveCredit",
  //         deleteKey: "DeletedCredits",
  //         table: "leave_cred",
  //       },
  //       {
  //         key: "Children",
  //         deleteKey: "DeletedChildren",
  //         table: "family_background",
  //       },
  //       {
  //         key: "Education",
  //         deleteKey: "DeleteEducation",
  //         table: "educational_background",
  //       },
  //       {
  //         key: "CivilService",
  //         deleteKey: "DeleteCivilSevice",
  //         table: "service_eligibility",
  //       },
  //       {
  //         key: "Voluntary",
  //         deleteKey: "DeleteVoluntary",
  //         table: "voluntary_work",
  //       },
  //       { key: "WorkExp", deleteKey: "DeleteWork", table: "work_experience" },
  //       {
  //         key: "LearningDev",
  //         deleteKey: "DeleteLearning",
  //         table: "learning_development",
  //       },
  //       {
  //         key: "OtherInfo",
  //         deleteKey: "DeleteOtherInfo",
  //         table: "other_information",
  //       },
  //       {
  //         key: "Reference",
  //         deleteKey: "DeleteReference",
  //         table: "reference_table",
  //       },
  //       {
  //         key: "Contributions",
  //         deleteKey: "DeleteContribution",
  //         table: "contributions",
  //       },
  //       {
  //         key: "AllowanceBene",
  //         deleteKey: "DeleteAllowance",
  //         table: "allowances",
  //       },
  //       {
  //         key: "Loans",
  //         deleteKey: "DeleteLoans",
  //         table: "loans",
  //       },
  //     ];

  //     for (const { key, deleteKey, table } of dataTypes) {
  //       await processSessionData(key, deleteKey, table, objectID);
  //     }

  //     this.CleanLocalStorage();
  //     sessionStorage.clear();
  //   } else {
  //     this.CleanLocalStorage();
  //     sessionStorage.clear();
  //   }
  // }

  setObject = (newObject) => {
    this.setState({ object: newObject }); // Update the state with the new object
  };

  render() {
    const object = this.state.object;
    const schema = this.getSchema(this.getCollectionName());
    const hasObjID = this.getObjectId();
    if (!schema) return <h1>No schema</h1>;
    // const user = this.getCurrentRoles().some(
    //   (item) => item.id === "Super Admin"
    // );
    // const hideAllTabs = user;
    const personalSchema = {
      ...schema,
      fields: Object.fromEntries(
        Object.entries(schema.fields).filter(([, value]) =>
          ["personal", "government", "contact"].includes(value.section),
        ),
      ),
    };

    const employmentSchema = {
      ...schema,
      fields: Object.fromEntries(
        Object.entries(schema.fields).filter(([, value]) =>
          ["emp"].includes(value.section),
        ),
      ),
    };

    const familySchema = {
      ...schema,
      fields: Object.fromEntries(
        Object.entries(schema.fields).filter(([, value]) =>
          ["spouse", "father", "mother"].includes(value.section),
        ),
      ),
    };
    // console.log("SHCEMA: ", schema);
    // console.log("PERSONAL: ", personalSchema);

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <CardView>
                <Steps
                  current={item.findIndex(
                    (menuItem) => menuItem.name === this.state.activeTab,
                  )}
                  onChange={(current) => {
                    if (hasObjID !== undefined) {
                      const activeTab = item[current].name;
                      this.setState({ activeTab });
                    } else {
                      return;
                    }
                  }}
                >
                  {item.map((menuItem) => (
                    <Steps.Step
                      key={menuItem.name}
                      title={menuItem.name}
                      description={menuItem.sub}
                    />
                  ))}
                </Steps>
              </CardView>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                {/* Render different pages based on active tab */}
                {this.state.activeTab === "Personal Information" && (
                  <PersonalInfo
                    presenter={this.presenter}
                    object={object}
                    schema={personalSchema}
                    setObject={this.setObject}
                    onChangeTab={this.onChangeTab.bind(this)}
                    onClickBack={this.navigateBack.bind(this)}
                    onClickPrev={this.onClickPrev.bind(this)}
                    object_ID={this.getObjectId()}
                    isSubmitting={this.state.isLoading}
                  />
                )}
                {this.state.activeTab === "Employment 201" && (
                  <Employment
                    object_ID={this.getObjectId()}
                    object={object}
                    schema={employmentSchema}
                    setObject={this.setObject}
                    onChangeTab={this.onChangeTab.bind(this)}
                    onClickBack={this.navigateBack.bind(this)}
                    onClickPrev={this.onClickPrev.bind(this)}
                    isSubmitting={this.state.isLoading}
                    // hideAllTabs={hideAllTabs}
                  />
                )}
                {this.state.activeTab === "Other Information" && (
                  <OtherInfo
                    presenter={this.presenter}
                    object_ID={this.getObjectId()}
                    object={object}
                    schema={familySchema}
                    onChangeTab={this.onChangeTab.bind(this)}
                    onClickBack={this.navigateBack.bind(this)}
                    onClickPrev={this.onClickPrev.bind(this)}
                    isSubmitting={this.state.isLoading}
                  />
                )}

                {this.state.activeTab === "Additional Information" && (
                  <AdditionalInfo
                    presenter={this.presenter}
                    object_ID={this.getObjectId()}
                    object={object}
                    onChangeTab={this.onChangeTab.bind(this)}
                    onClickBack={this.navigateBack.bind(this)}
                    onClickPrev={this.onClickPrev.bind(this)}
                    isSubmitting={this.state.isLoading}
                  />
                )}

                {this.state.activeTab === "Attachments" && (
                  <Attachment
                    presenter={this.presenter}
                    object_ID={this.getObjectId()}
                    object={object}
                    onClickBack={this.navigateBack.bind(this)}
                    onClickPrev={this.onClickPrev.bind(this)}
                    setObject={this.setObject}
                    isSubmitting={this.state.isLoading}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.isLoading && (
          <FloatingForm width={"30rem"}>
            <CardView>
              <div className="d-grid align-items-center justify-content-center p-5">
                <Spin size="large" />
                <span>Loading...</span>
              </div>
            </CardView>
          </FloatingForm>
        )}
      </>
    );
  }
}

export default withRouter(EmployeeFormPage);
